/* globals jQuery scriptVariables */

import AnchorBlock from "./modules/anchor_block";
import svgxhr from 'webpack-svgstore-plugin/src/helpers/svgxhr';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Swiper from 'swiper/dist/js/swiper.js';
import MicroModal from 'micromodal';
import loadGoogleMapsApi from 'load-google-maps-api';
import Choices from 'choices.js';
import LocationViewer from './modules/locations';
import WOW from 'wow.js';
import { CountUp } from 'countup.js';
import Masonry from 'masonry-layout';
import CustomDropdown from "./modules/CustomDropdown";
import HeaderBlock from './modules/header_block';

import Navbar from './modules/Navbar';
import PageNavigation from "./modules/PageNavigation";

if (!document.scrollingElement) {
    document.scrollingElement = (document.documentElement) ? document.documentElement : document.body;
}

window.namespace = {
    init: function () {
        if (typeof NodeList.prototype.forEach !== 'function') {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        // ?trim inner html on buttons
        (document.querySelectorAll('.btn') ?? [])
            .forEach(el => {

                const isTargetElement = !(
                    el.classList.contains('btn--filled')
                    || el.classList.contains('btn--white')
                    || el.querySelector('span') !== null
                );

                if (isTargetElement) {
                    el.innerHTML = `<span>${el.innerHTML.trim()}</span>`;
                }
            });

        jQuery(window).keydown(function (e) {
            if (e.keyCode == 192) debugger;
        });

        // Initialise ChoicesJs (Custom Dropdowns)
        (document.querySelectorAll('select:not(.ninja-forms-field)') ?? [])
            .forEach(el => {
                el.choices = new Choices(el, {
                    searchEnabled: false
                });
            });

        // FIXME: Ninja Forms Select Fields ChoicesJS
        // $(document).on( 'nfFormReady', function(e) {
        //
        //     // Select input select fields that are not instances of ChoicesJS
        //     const selectFieldSelector = 'select.ninja-forms-field:not(.choices__input)';
        //     let selectFields = document.querySelectorAll(selectFieldSelector);
        //
        //     selectFields.forEach(el => {
        //         el.choices = new Choices(el, {
        //             searchEnabled: false
        //         });
        //     });
        // });

        // Initialise the logo swiper
        (document.querySelectorAll('.logo-swiper') ?? [])
            .forEach(el => {
                el.swiper = new Swiper(el, {
                    slidesPerView: 7,
                    centeredSlides: false,
                    spaceBetween: 30,
                    loop: true,
                    breakpoints: {
                        840: {
                            slidesPerView: 'auto',
                            centeredSlides: true,
                        }
                    },
                    navigation: {
                        nextEl: '.button-next',
                        prevEl: '.button-prev',
                    }
                })
            });

        // Initialise Page Swiper
        (document.querySelectorAll('.page-swiper') ?? [])
            .forEach(el => {
                el.swiper = new Swiper(el, {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 20,
                    autoplay: {
                        delay: 16000,
                    },
                    breakpoints: {
                        840: {
                            slidesPerView: 1,
                        }
                    },
                    on: {
                        init: function () {
                            this.slideTo(1);
                        }
                    }
                });
            });

        // Initialise Home Swiper
        (document.querySelectorAll('#home-swiper') ?? [])
            .forEach(el => {
                el.swiper = new Swiper(el, {
                    effect: 'fade',
                    allowTouchMove: false,
                    speed: 500,
                    autoplay: {
                        delay: 12000,
                    },
                    fadeEffect: {
                        crossFade: true
                    },
                });
            });

        // Initialise People Swiper
        (document.querySelectorAll('.people-swiper') ?? [])
            .forEach(el => {

                el.swiper = new Swiper(el, {
                    allowTouchMove: false
                });

                (el.previousElementSibling.querySelectorAll('li button') ?? [])
                    .forEach((btn, index) => {
                        btn.addEventListener('click', e => {
                            e.preventDefault();

                            (el.previousElementSibling.querySelectorAll('li button') ?? [])
                                .forEach(el => el.classList.remove('tab--active'));

                            el.swiper.slideTo(index);
                            e.target.classList.add('tab--active');
                        });
                    });
            });

        // Initialize Twitter Feed
        (document.querySelectorAll('.twitter-feed') ?? [])
            .forEach(el => {
                el.twitter = new Swiper(el, {
                    slidesPerView: 4,
                    centeredSlides: false,
                    spaceBetween: 20,
                    on: {
                        init: function () {
                            this.wrapperEl.querySelectorAll('.swiper-slide').forEach(el => {
                                el.style.height = this.wrapperEl.offsetHeight + 'px';
                            });
                        },
                        resize: function () {
                            this.wrapperEl.querySelectorAll('.swiper-slide').forEach(el => {
                                el.style.height = this.wrapperEl.offsetHeight + 'px';
                            });
                        }
                    },
                    breakpoints: {
                        // when window width is <= 640px
                        1120: {
                            slidesPerView: 3,
                        },
                        840: {
                            slidesPerView: 2,
                        },
                        575: {
                            slidesPerView: 1,
                        }
                    }
                });
            });

        this.maps.contact();
        this.maps.locations();
        this.vacancies();
        MicroModal.init();
        this.personModals();
        HeaderBlock.init();

        // Initialise Navbar
        (document.querySelectorAll('#navbar') ?? []).forEach(el => new Navbar(el));
        // Initialise PageNavigation
        (document.querySelectorAll('#page-navigation') ?? []).forEach(el => new PageNavigation(el));

        (document.querySelectorAll('input[type="file"]') ?? [])
            .forEach(el => {
                el.addEventListener('change', ev => {
                    let path = ev.target.value.split('\\');
                    path = path[path.length - 1];

                    ev.target.nextElementSibling.innerHTML = path;
                });
            });

        let gutter = (navigator.userAgent.indexOf('MSIE') !== -1
            || navigator.appVersion.indexOf('Trident/') > -1) ? 15 : 13;
        let cards = document.querySelector('.news-container')
        if (cards && window.innerWidth >= 1200) {
            let anchorDateSmall = new AnchorBlock('.news-post--small h3', true, true, 2);
            let anchorDateLarge = new AnchorBlock('.news-post--large h3', true, true, 2);
            var grid = new Masonry(cards, {
                gutter: '.gutter-sizer',
                horizontalOrder: true,
                itemSelector: '.news-post',
                columnWidth: 295,
                // percentPosition: true,
                // percentPosition: true,
            })
        }

        // news posts filter
        (document.querySelectorAll('.custom-dropdown') ?? [])
            .forEach(dropdown => new CustomDropdown(dropdown));

        let wow = new WOW({
            boxClass: 'wow',          // animated element css class (default is wow)
            animateClass: 'animated', // animation css class (default is animated)
            offset: 150,              // distance to the element when triggering the animation (default is 0)
            mobile: true,             // trigger animations on mobile devices (default is true)
            live: false,              // act on asynchronously loaded content (default is true)
            callback: box => {
                box.classList.add('hit');

                if (box.classList.contains('stat')) {
                    let title = box.querySelector('[data-number]');

                    if (typeof title.dataset.number !== 'undefined') {
                        let number = title.dataset.number.replace(/[^\d\.\-]/g, "");
                        let demo = new CountUp(title, parseFloat(number), {
                            duration: 2.6,
                            easingFn: function (t, b, c, d) {
                                let ts = (t /= d) * t,
                                    tc = ts * t;

                                return b + c * (tc + -3 * ts + 3 * t);
                            }
                        });

                        if (!demo.error) {
                            demo.start();
                        } else {
                            console.warn(demo.error);
                        }
                    }
                }
                // the callback is fired every time an animation is started
                // the argument that is passed in is the DOM node being animated
            },
            resetAnimation: false, // reset animation on end (default is true)
        });

        wow.init();

        //Allow user to interrupt auto-scrolling
        $(document).bind('scroll mousedown wheel keyup', function (e) {
            if (e.which || e.type === 'mousedown' || e.type === 'mousewheel') {
                $(document.scrollingElement).stop();
            }
        });

        (document.querySelectorAll('.page-scroll') ?? [])
            .forEach(el => {
                el.addEventListener('click', this.helpers.pageScroll);
            });
    },
    vacancies: function () {
        (document.querySelectorAll('.vacancy button') ?? [])
            .forEach(el => {
                el.addEventListener('click', ev => {
                    ev.preventDefault();

                    let id = ev.target.dataset.id,
                        form = document.querySelector('[aria-label="Job Application"]');

                    if (form !== null) {
                        let select = form.querySelector('.job-role select');

                        if (typeof select.choices !== 'undefined') {
                            select.choices.setChoiceByValue(id);
                        } else {
                            select.value = id;
                        }
                    }

                    jQuery('body, html').animate({
                        scrollTop: $(form).offset().top - 100
                    }, 400);
                });
            });
    },
    personModals: function () {
        let modal = document.querySelector('#person-details');
        if (document.querySelector('.person') !== null && modal !== null) {
            document.querySelectorAll('.person').forEach(el => {
                el.addEventListener('click', ev => {
                    ev.preventDefault();

                    if (!el.dataset.copy) {
                        return;
                    }

                    modal.querySelector('.modal__title').innerHTML = (typeof el.dataset.name !== 'undefined') ? el.dataset.name : '';
                    modal.querySelector('.modal__title').dataset.job = (typeof el.dataset.job !== 'undefined') ? el.dataset.job : '';
                    modal.querySelector('.modal__content').innerHTML = (typeof el.dataset.copy !== 'undefined') ? el.dataset.copy : '';

                    if (el.dataset.email.length) {
                        modal.querySelector('.modal__content').insertAdjacentHTML('beforeend', `<a href="mailto:${el.dataset.email}" class="btn btn--outline"><span>Contact</span></a>`)
                    }

                    MicroModal.show('person-details');
                });
            });
        }
    },
    maps: {
        contact: function () {
            let maps = document.querySelectorAll('.mapbox');

            maps.forEach(el => {
                el.markers = [];

                if (typeof el.dataset.lat === 'undefined' || typeof el.dataset.lng === 'undefined') {
                    return false;
                }

                loadGoogleMapsApi({key: 'AIzaSyAc4qeSw9vL5jXPnI12LbPKI7KnoZm5Sa4'}).then(mapsApi => {
                    el.map = new mapsApi.Map(el, {
                        center: {lat: parseFloat(el.dataset.lat), lng: parseFloat(el.dataset.lng)},
                        zoom: 15,
                        disableDefaultUI: true,
                        draggable: false,
                        styles: [
                            {
                                "featureType": "all",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    { "saturation": 36 },
                                    { "color": "#333333" },
                                    { "lightness": 40 }
                                ]
                            },
                            {
                                "featureType": "all",
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                    { "visibility": "on" },
                                    { "color": "#ffffff" },
                                    { "lightness": 16 }
                                ]
                            },
                            {
                                "featureType": "all",
                                "elementType": "labels.icon",
                                "stylers": [
                                    { "visibility": "off" }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    { "color": "#f6f6f6" },
                                    { "lightness": 20 }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    { "color": "#fefefe" },
                                    { "lightness": 17 },
                                    { "weight": 1.2 }
                                ]
                            },
                            {
                                "featureType": "landscape",
                                "elementType": "geometry",
                                "stylers": [
                                    { "color": "#ebebec" },
                                    { "lightness": 20 }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry",
                                "stylers": [
                                    { "color": "#e2d3dc" },
                                    { "lightness": "0" }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "geometry",
                                "stylers": [
                                    { "color": "#d0b1c4" },
                                    { "lightness": "00" }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    { "color": "#ffffff" },
                                    { "lightness": 17 }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    { "color": "#ffffff" },
                                    { "lightness": 29 },
                                    { "weight": 0.2 }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "geometry",
                                "stylers": [
                                    { "color": "#ffffff" },
                                    { "lightness": 18 }
                                ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "geometry",
                                "stylers": [
                                    { "color": "#ffffff" },
                                    { "lightness": 16 }
                                ]
                            },
                            {
                                "featureType": "transit",
                                "elementType": "geometry",
                                "stylers": [
                                    { "color": "#f2f2f2" },
                                    { "lightness": 19 }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "geometry",
                                "stylers": [
                                    { "color": "#b781a0" },
                                    { "lightness": "0" }
                                ]
                            }
                        ]
                    });

                    el.marker = new mapsApi.Marker({
                        position: {lat: parseFloat(el.dataset.lat), lng: parseFloat(el.dataset.lng)},
                        map: el.map,
                        icon: {
                            url: '/wp-content/themes/class/dist/images/icons/map-marker.png',
                            size: new mapsApi.Size(120, 172),
                            scaledSize: new mapsApi.Size(60, 86),
                            origin: new mapsApi.Point(0, 0),
                            anchor: new mapsApi.Point(30, 86)
                        }
                    });
                });

                return true;
            });
        },
        locations: function () {
            if (document.querySelector('.locations') === null) {
                return false;
            }

            document.querySelectorAll('.locations').forEach(el => {
                console.log('maps.locations:foreach');
                el.locations = new LocationViewer(el);
            });

            return true;
        }
    },
    helpers: {
        getScrollbarWidth: function () {
            let outer = document.createElement("div");
            outer.style.visibility = "hidden";
            outer.style.width = "100px";
            outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

            document.body.appendChild(outer);

            let widthNoScroll = outer.offsetWidth;
            // force scrollbars
            outer.style.overflow = "scroll";

            // add inner div
            let inner = document.createElement("div");
            inner.style.width = "100%";
            outer.appendChild(inner);

            let widthWithScroll = inner.offsetWidth;

            // remove divs
            outer.parentNode.removeChild(outer);

            return widthNoScroll - widthWithScroll;
        },
        pageScroll: function (e) {
            e.preventDefault();

            let headerHeight = document.querySelector('.home-header-wrapper').getBoundingClientRect().height;

            $('html, body').animate({scrollTop: headerHeight}, 800);
        },
    }
};

window.namespace.init();

// Prefer creating new modules when appropriate, rather than adding functions here
//  if you need something to be globally accessible, you can assign an imported module to this namespace
//  i.e. import Contact from './contact';
//  window.namespace.Contact = Contact;

// SVG Sprite Loader
// eslint-disable-next-line no-unused-vars
const __sprite__ = {
    path: '../../resources/images/icons/**/*.svg', //Source SVGs path relative to the compiled js (dist/js)
    name: 'images/icons.svg', //Compiled file path relative to dist/
};

svgxhr({
    filename: './wp-content/themes/class/dist/images/icons.svg', //URL to fetch
});
